import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import { useAuth } from '../../../contexts/AuthContext';



const EmailTemplateCard = ({ template, onEdit }) => {
  const { isAuthenticated } = useAuth();
  const [isExpanded, setIsExpanded] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);
  const [downloadSuccess, setDownloadSuccess] = useState(false);

  const handleCopyContent = async () => {
    const fullContent = `Subject: ${template?.subject}\n\nPreview Text: ${template?.previewText}\n\n${template?.bodyContent}\n\nCTA: ${template?.ctaText}`;
    
    try {
      await navigator.clipboard?.writeText(fullContent);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (error) {
      console.error('Failed to copy:', error);
    }
  };

  const handleDownload = () => {
    const fullContent = `Subject: ${template?.subject}\n\nPreview Text: ${template?.previewText}\n\n${template?.bodyContent}\n\nCTA: ${template?.ctaText}`;
    const blob = new Blob([fullContent], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${template?.title?.replace(/\s+/g, '_')}_template.txt`;
    document.body?.appendChild(link);
    link?.click();
    document.body?.removeChild(link);
    URL.revokeObjectURL(url);
    
    setDownloadSuccess(true);
    setTimeout(() => setDownloadSuccess(false), 2000);
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden hover:shadow-lg transition-all duration-250">
      <div className="p-4 md:p-6">
        <div className="flex items-start justify-between mb-3">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium text-foreground" style={{ backgroundColor: 'var(--corvid-background-color, rgba(var(--bg, var(--color_17, 37, 99, 235)), var(--alpha-bg, 1)))' }}>
                {template?.category === 'technology' ? 'Technology' :
                 template?.category === 'educational' ? 'Educational' :
                 template?.category === 'trust'? 'Trust Building' : 'Seasonal'}
              </span>
              {template?.isNew && (
                <span className="inline-flex items-center px-2 py-1 rounded text-xs font-medium bg-success/10 text-success">
                  New
                </span>
              )}
            </div>
            <h3 className="text-lg md:text-xl font-semibold text-foreground mb-2 line-clamp-2">
              {template?.title}
            </h3>
            <p className="text-sm text-muted-foreground line-clamp-2 mb-3">
              {template?.description}
            </p>
          </div>
        </div>

        <div className="space-y-3 mb-4">
          <div className="bg-muted/50 rounded-lg p-3">
            <p className="text-xs font-medium text-muted-foreground mb-1 font-caption">Subject Line:</p>
            <p className="text-sm text-foreground font-medium line-clamp-2">{template?.subject}</p>
          </div>

          {isExpanded && (
            <>
              <div className="bg-muted/50 rounded-lg p-3">
                <p className="text-xs font-medium text-muted-foreground mb-1 font-caption">Preview Text:</p>
                <p className="text-sm text-foreground">{template?.previewText}</p>
              </div>

              <div className="bg-muted/50 rounded-lg p-3">
                <p className="text-xs font-medium text-muted-foreground mb-1 font-caption">Email Body:</p>
                <p className="text-sm text-foreground whitespace-pre-line">{template?.bodyContent}</p>
              </div>

              <div className="bg-muted/50 rounded-lg p-3">
                <p className="text-xs font-medium text-muted-foreground mb-1 font-caption">Call to Action:</p>
                <p className="text-sm text-foreground font-medium">{template?.ctaText}</p>
              </div>
            </>
          )}
        </div>

        <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 pt-3 border-t border-border">
          <Button
            variant="outline"
            size="sm"
            onClick={() => setIsExpanded(!isExpanded)}
            iconName={isExpanded ? 'ChevronUp' : 'ChevronDown'}
            iconPosition="right"
            className="flex-1 sm:flex-initial"
          >
            {isExpanded ? 'Show Less' : 'View Full Template'}
          </Button>

          <div className="flex items-center gap-2 flex-1 sm:flex-initial sm:ml-auto">
            {isAuthenticated && onEdit && (
              <Button
                variant="outline"
                size="sm"
                onClick={() => onEdit(template)}
                iconName="Edit"
                iconPosition="left"
                className="flex-1 sm:flex-initial"
              >
                Edit
              </Button>
            )}
            
            <Button
              variant={copySuccess ? 'success' : 'outline'}
              size="sm"
              onClick={handleCopyContent}
              iconName={copySuccess ? 'Check' : 'Copy'}
              iconPosition="left"
              className="flex-1 sm:flex-initial min-w-[100px]"
            >
              {copySuccess ? 'Copied!' : 'Copy'}
            </Button>

            <Button
              variant={downloadSuccess ? 'success' : 'default'}
              size="sm"
              onClick={handleDownload}
              iconName={downloadSuccess ? 'Check' : 'Download'}
              iconPosition="left"
              className="flex-1 sm:flex-initial min-w-[120px]"
            >
              {downloadSuccess ? 'Downloaded!' : 'Download'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailTemplateCard;